import { HomePage } from "./../home/home";
import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-qrresult",
  templateUrl: "qrresult.html",
})
export class QrresultPage {
  text: any;
  theme = 1;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    this.text = this.navParams.data.text;
    console.log(this.text);
  }

  backHome() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/qrresult/qrresult.ts